import { Chip as MuiChip, makeStyles } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 'unset',
    backgroundColor: ({ themeColor }) =>
      theme.colors[themeColor] ?? themeColor ?? theme.colors.greyE8,
    cursor: 'inherit',
  },

  label: {
    ...theme.typography.body2,
    paddingLeft: 8,
    paddingRight: 8,
    color: ({ labelColor }) => {
      return (
        `${theme.colors[labelColor]} !important` ??
        `${labelColor} !important` ??
        `${theme.colors.grey66} !important`
      );
    },
  },

  labelSmall: {
    ...theme.typography.caption,
    paddingTop: 1,
    paddingBottom: 1,
  },

  labelLarge: {
    ...theme.typography.h5,
    padding: '6px 12px',
  },
}));

function Chip(props) {
  const { size, themeColor, labelColor, classes: classesProp, ...otherProps } = props;
  const classes = useStyles({ themeColor, labelColor });

  return (
    <MuiChip
      {...otherProps}
      classes={mergeClasses({
        baseClasses: {
          root: classes.root,
          label: classNames(
            classes.label,
            size === 'small' && classes.labelSmall,
            size === 'large' && classes.labelLarge
          ),
        },
        newClasses: classesProp,
      })}
    />
  );
}

Chip.propTypes = {
  size: PropTypes.oneOf(['small', 'large']),
  themeColor: PropTypes.string,
  labelColor: PropTypes.string,
  classes: PropTypes.object,
};

export default Chip;
